import { useContext } from 'react';

import { RecommendationConfigContext } from '../components';

export default function useRecommendationConfig() {
  return useContext(RecommendationConfigContext);
}
